var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDarkRounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#dark-rounded_svg__clip0_1208_262)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20zm6.997-7.98H22.82V11.266h-1.865c-3.419 0-5.215 1.727-5.215 4.282 0 2.9 1.244 4.248 3.799 5.974l2.107 1.416-6.078 9.082h-4.524l5.456-8.115c-3.142-2.245-4.903-4.42-4.903-8.115 0-4.627 3.211-7.77 9.323-7.77h6.078v24z",
  fill: "#fff"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "dark-rounded_svg__clip0_1208_262"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#fff"
})))));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEyMDhfMjYyKSI+CjxyZWN0IHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgcng9IjIwIiBmaWxsPSJibGFjayIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIwIDQwQzMxLjA0NTkgNDAgNDAgMzEuMDQ1NiA0MCAyMEM0MCA4Ljk1NDM3IDMxLjA0NTkgMCAyMCAwQzguOTU0MTYgMCAwIDguOTU0MzcgMCAyMEMwIDMxLjA0NTYgOC45NTQxNiA0MCAyMCA0MFpNMjYuOTk3MSAzMi4wMkgyMi44MTg2VjExLjI2NjFIMjAuOTU0QzE3LjUzNTEgMTEuMjY2MSAxNS43Mzk1IDEyLjk5MjcgMTUuNzM5NSAxNS41NDgxQzE1LjczOTUgMTguNDQ4NyAxNi45ODI3IDE5Ljc5NTUgMTkuNTM4IDIxLjUyMjFMMjEuNjQ0NiAyMi45MzhMMTUuNTY2NyAzMi4wMkgxMS4wNDMxTDE2LjQ5OTQgMjMuOTA0OUMxMy4zNTY2IDIxLjY2MDIgMTEuNTk1NSAxOS40ODQ3IDExLjU5NTUgMTUuNzg5N0MxMS41OTU1IDExLjE2MjUgMTQuODA3MSA4LjAyIDIwLjkxOTUgOC4wMkgyNi45OTcxVjMyLjAyWiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xMjA4XzI2MiI+CjxyZWN0IHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgcng9IjIwIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgDarkRounded as ReactComponent };